import Cookies from 'js-cookie';
import { isNil } from 'lodash';

export const ACCESS_TOKEN = 'rs-internal-accessToken';
export const REFRESH_TOKEN = 'rs-internal-refreshToken';

export type UserTokens = {
  accessToken?: string;
  refreshToken?: string;
};

export const setAuthTokens = (action: { payload: UserTokens }) => {
  const { accessToken, refreshToken } = action.payload;

  if (!isNil(accessToken)) {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
  }
  if (!isNil(refreshToken)) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
};

export const getAuthTokens = (): UserTokens => {
  const internalCookie = Cookies.get(ACCESS_TOKEN);
  const internalRefreshCookie = Cookies.get(REFRESH_TOKEN);
  if (internalCookie) {
    setAuthTokens({ payload: { accessToken: internalCookie } });
  }
  if (internalRefreshCookie) {
    localStorage.setItem(REFRESH_TOKEN, internalRefreshCookie);
  }
  return {
    accessToken:
      internalCookie ?? localStorage.getItem(ACCESS_TOKEN) ?? undefined,
    refreshToken:
      internalRefreshCookie ?? localStorage.getItem(REFRESH_TOKEN) ?? undefined,
  };
};

export const resetAuthTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
};
